import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/tokens.css";
import "./styles/pwa-tokens.css";
import "./styles/portal-dark-theme.css";
import "./styles/desktop-portal.css";
import "./styles/desktop-portal-dark.css";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store/store";
import { BrowserRouter } from "react-router";
import { HelmetProvider } from "react-helmet-async";
import { installPwaRecoveryHandlers } from "./utils/pwaRecovery";
import { hideBootSplash, isPortalAppPath } from "./utils/bootSplash";
import { isClinicPortal } from "./utils/portalHost";

installPwaRecoveryHandlers();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </HelmetProvider>
);

/* Порталы клуба сразу показывают свой splash — HTML-заглушку убираем.
   На платформе держим boot-splash, пока App не сообщит, что init готов. */
const path = typeof window !== "undefined" ? window.location.pathname : "";
if (isClinicPortal() || isPortalAppPath(path)) {
  hideBootSplash();
} else {
  window.setTimeout(hideBootSplash, 12000);
}
